import React, { Component } from 'react';
import * as styled from '../../styles/style';
import SignupForm from '../forms/SignupForm';
import Notification from '../Notification';
import ReactPixel from 'react-facebook-pixel';
import { history } from '../../helpers/history';
import Loading from '../Loading'

class Register extends Component {

	constructor(props) {
		super(props);
		this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGoto = this.handleGoto.bind(this);

    if (localStorage.getItem('auth_token')) {
      this.props.loadUserFromToken()
    }
	}

  handleGoto() {
    if (this.props.currentUser.role === 'admin') {
      window.top.location.href = "/host/admin/events";
    }
    else if (this.props.currentUser.role === 'host') {
      window.top.location.href = "/host/hub/dashboard";
    }
    else {
      window.top.location.href = "/";
    }
  }

	handleSubmit(email, passwordDigest) {
		ReactPixel.init('1686644521647441');
		ReactPixel.trackCustom('CompleteRegistration', { status: 'complete' });
    return this.props.register(email, passwordDigest);
  }

  render() {
    let { userLoading, currentUser } = this.props
    let loading = userLoading
    return (
      <styled.Main>
        {loading ? <Loading/> :
          <React.Fragment>
          {currentUser ?
            <React.Fragment>
              <styled.Disclaimer style={{ marginTop: 0 }}>Looks like you're signed in:</styled.Disclaimer>
              <styled.ButtonGroup style={{ marginTop: '16px' }}>
                <styled.Button onClick={this.handleGoto} type="submit" value="Go to Host Hub" />
              </styled.ButtonGroup>
            </React.Fragment>
          :
            <React.Fragment>
              <Notification type={this.props.alertType} message={this.props.alertMessage} />
              {/*<styled.SubHeading>Register to Host</styled.SubHeading>
      				<p style={{marginTop: 0, marginBottom: '30px', textAlign: 'center'}}><span style={{color: 'red'}}>*</span> = Required</p>*/}
              {/*<SignupForm handleSubmit={this.handleSubmit}/>*/}
              <div style={{ textAlign: 'center' }}>
                <h1>Registration is Now Closed</h1>
              </div>
              {/*<styled.SubHeading>Thank you for your interest, but registration is now closed for 2019.</styled.SubHeading>*/}
            </React.Fragment>
          }</React.Fragment>
        }
      </styled.Main>
    )
  }
}

export default Register
